import ProductDescription from './ProductDescription'

const CornTortillaProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '007',
  IsBroadband: false,
  Size: '',
}

export default CornTortillaProduct
